import CounterStore from "./counter";

export default (Alpine) => {

    Alpine.store("counter", CounterStore);

};